import { Controller } from "@hotwired/stimulus";

// Targets a turbo frame only above a breakpoint. Below it the link is retargeted
// at _top, so it becomes a full page visit -- which is what the message center
// wants on mobile, where the panes are shown one at a time rather than side by
// side. _top rather than no attribute at all: the link sits inside a turbo
// frame, so with no target Turbo would navigate that frame instead.
export default class extends Controller {
  static values = {
    frame: String,
    media: { type: String, default: "(min-width: 640px)" },
  };

  connect() {
    this.query = window.matchMedia(this.mediaValue);
    this.update = this.update.bind(this);
    this.update();
    this.query.addEventListener("change", this.update);
  }

  disconnect() {
    this.query.removeEventListener("change", this.update);
  }

  update() {
    this.element.setAttribute(
      "data-turbo-frame",
      this.query.matches ? this.frameValue : "_top",
    );
  }
}
